
import React, { useState , useContext} from "react";
import Email  from '../Myaccount/accountmanagement/Email';
import Mobile  from '../Myaccount/accountmanagement/Mobile';
import {  changeDateFotmate, currencySymbol , loggedInUserDetails , loggedInCustomerDetails } from '../../functions/Function';
import  { WebContext }  from "../../Webroute";

const  Management = (props) => {
    const WebData = useContext(WebContext);
    const [emailmodalShow, setEmailModalShow] = React.useState(false);
    const [mobilemodalShow, setMobileModalShow] = React.useState(false);
  return (
    <>
            <Email show={emailmodalShow}
                onHide={() => setEmailModalShow(false)} 
            />
             <Mobile show={mobilemodalShow}
                onHide={() => setMobileModalShow(false)} 
            />
             <div className="account-right-content-shdow">
                                <h5 className="account-tab-heading">Account Management </h5>
                                <ul className="account-profile-contentent account-Management-contentent">

                                    <li>
                                        <div className="d-flex align-items-center">
                                            <div className="profile-avatar profile-icon">
                                                <i className="fa-solid fa-envelope"></i>
                                            </div>
                                            <div className="profile-avatar-content">

                                                <div className="profile-scond-h">
                                                    Change Email Address
                                                </div>
                                            </div>
                                        </div>
                                        <div className="management-ancor"> 
                                        <span className="edit-Btn-account" onClick={() => setEmailModalShow(true)}>Edit</span>
                                        
                                        </div>

                                       
                                    </li>
                                    <li>
                                        <div className="d-flex align-items-center">
                                            <div className="profile-avatar profile-icon">
                                                <i className="fa-solid fa-phone"></i>
                                            </div>
                                            <div className="profile-avatar-content">

                                                <div className="profile-scond-h">
                                                    Change Mobile Number
                                                </div>
                                            </div>
                                        </div>

                                        <div className="management-ancor"><span onClick={() => setMobileModalShow(true)}>
                                        {WebData.customer.phone == '' ?
                                                'Add'
                                            : 
                                                'Edit'
                                            }
                                            
                                        </span></div>
                                       
                                    </li>

                                </ul>
                            </div>
    </>

  );
}

export default Management;
